import { render, staticRenderFns } from "./OrderDetailInfo.vue?vue&type=template&id=a8732e54"
import script from "./OrderDetailInfo.vue?vue&type=script&lang=js"
export * from "./OrderDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailInfo.vue?vue&type=style&index=0&id=a8732e54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports